/**
 * 「回工作台改这稿」交接包(2026-08-07 R2-c)。
 *
 * 详情页把本片的 settings 交给创建页预填。★验型器只认**后端真回了的**那几个字段:
 * 形象(avatarRef)后端 DTO 里根本没有,所以这里也没有 —— 交接包里不许出现一个
 * 到了创建页也落不了地的字段(存量教训:样片 recipe 与爆款 blueprint 混填出过错配档案)。
 */
export interface DhRemakeHandoff {
  fromTaskId: number;
  mode?: string;
  script?: string;
  resolution?: string;
  speechRate?: number;
  presetVoice?: string;
  voiceSource?: string;
  performanceStyle?: string;
  /** 声音 V2 三件套(2026-09-08;仅声纹路任务的 settings 回它们,老任务缺省)。 */
  voiceLanguage?: string;
  voiceDialect?: string | null;
  voiceStyle?: string;
  burnSubtitles?: boolean;
}

/** 从 `location.state` 里取交接包;形状不对一律返回 null(不半信半疑地用一半)。 */
export function parseDhRemakeState(state: unknown): DhRemakeHandoff | null {
  if (!state || typeof state !== "object") return null;
  const raw = (state as { dhRemake?: unknown }).dhRemake;
  if (!raw || typeof raw !== "object") return null;
  const r = raw as Record<string, unknown>;
  if (typeof r.fromTaskId !== "number") return null;
  return {
    fromTaskId: r.fromTaskId,
    ...(typeof r.mode === "string" ? { mode: r.mode } : {}),
    ...(typeof r.script === "string" ? { script: r.script } : {}),
    ...(typeof r.resolution === "string" ? { resolution: r.resolution } : {}),
    ...(typeof r.speechRate === "number" ? { speechRate: r.speechRate } : {}),
    ...(typeof r.presetVoice === "string" ? { presetVoice: r.presetVoice } : {}),
    ...(typeof r.voiceSource === "string" ? { voiceSource: r.voiceSource } : {}),
    ...(typeof r.performanceStyle === "string" ? { performanceStyle: r.performanceStyle } : {}),
    // 声音 V2:voiceDialect 的 null 是有意义的值(=普通话),与「没带」区分开。
    ...(typeof r.voiceLanguage === "string" ? { voiceLanguage: r.voiceLanguage } : {}),
    ...(typeof r.voiceDialect === "string" || r.voiceDialect === null
      ? { voiceDialect: r.voiceDialect }
      : {}),
    ...(typeof r.voiceStyle === "string" ? { voiceStyle: r.voiceStyle } : {}),
    ...(typeof r.burnSubtitles === "boolean" ? { burnSubtitles: r.burnSubtitles } : {}),
  };
}

/** 档位 → 创建页片型。api 的 mode 是四档,创建页的片型是三选一(照片档下再分档位)。 */
export function filmTypeOfMode(mode: string | undefined): "video" | "photo" | "tts" | null {
  if (mode === "video") return "video";
  if (mode === "tts") return "tts";
  if (mode === "flagship" || mode === "longform") return "photo";
  return null;
}
